import { render } from "./VideoBlock.vue?vue&type=template&id=9e8c7fe0&scoped=true"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"

import "./VideoBlock.vue?vue&type=style&index=0&id=9e8c7fe0&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./VideoBlock.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e8c7fe0"]])

export default __exports__